import { Navbar } from "@/components/landing/Navbar";
import { Hero } from "@/components/landing/Hero";
import { Benefits } from "@/components/landing/Benefits";
import { Services } from "@/components/landing/Services";
import { About } from "@/components/landing/About";
import { Process } from "@/components/landing/Process";
import { Testimonials } from "@/components/landing/Testimonials";
import { Contact } from "@/components/landing/Contact";
import { Footer } from "@/components/landing/Footer";
import { MessageCircle } from "lucide-react";
import { site } from "@/data/site";

export default function Landing() {
  return (
    <div className="bg-background">
      <Navbar />
      <main>
        <Hero />
        <Benefits />
        <Services />
        <About />
        <Process />
        <Testimonials />
        <Contact />
      </main>
      <Footer />

      <a
        href={site.whatsapp}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="floating-whatsapp"
        className="fixed bottom-6 right-6 z-50 w-14 h-14 rounded-full bg-white text-black flex items-center justify-center shadow-2xl hover:scale-105 transition-transform"
        aria-label="WhatsApp Kontakt"
      >
        <MessageCircle className="w-6 h-6" />
      </a>
    </div>
  );
}
